import { Card } from "flowbite-react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div id="not-found" className="p-4 md:p-8 w-full max-h-min">
      <Card className="max-w-sm">
        <h5 className="text-2xl font-bold tracking-tight text-primary-main">
          404 Error!
        </h5>
        <p className="font-normal text-gray-700">
          Halaman yang Anda cari tidak ditemukan!
        </p>
        <Link to="/">
          <button
            type="submit"
            className="bg-primary-main hover:bg-primary-dark text-white p-2 font-semibold rounded-lg text-sm text-center px-5 py-3 duration-300"
          >
            Kembali ke Dashboard
          </button>
        </Link>
      </Card>
    </div>
  );
};

export default NotFound;
